import React from 'react';
import TextFieldProto from './text-proto.jsx';


export default function renderTextInFormNew(id, props) {
    return <TextFieldProto renderMode="form-new" id={id} {...props} />;
}